var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('oil-cap',{attrs:{"title":'пользователи системы'.toUpperCase(),"buttons":[
                {
                  route: 'user',
                  name: 'добавить пользователя'
                }
      ]}}),_c('oil-table',{attrs:{"items":_vm.users,"rowClick":_vm.rowClick,"keys":[
        {text:'Полное имя',value:'FullName'},
        {text:'Имя пользователя',value:'Username'},
        {text:'Адрес электронной почты',value:'Email'},
        {text:'Роль',value:'Role'} ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }